module.exports = __webpack_public_path__ + "static/media/logo.8414fdd7.svg";